/**
 * TR COURSE PAGE
 */

import { GetServerSideProps } from "next";
import { serverSideTranslations } from "../../../common/utility/serverSideTranslations";
import { getSelectorsByUserAgent } from "react-device-detect";
import CoursePage from "../../../domains/qi/pages/coursePage/coursePage";
import {
  getCachedCourses,
  getSingleCachedCourse,
} from "../../../domains/qi/services/cachedCourseService";
import { convertLangToXLocale } from "../../../domains/qi/services/utiltyService";
import { IKunduzRequest } from "../../../common/interfaces";
import { initalizeMiddlewares } from "../../../common/middlewares";
import { saveContentLangToCookie } from "../../../common/services/utilityService";
import { getCachedHeaderItems } from "../../../common/services/cachedHeaderItems";
import { getCachedHeaderBanner } from "../../../common/services/cachedHeaderBanner";

export default function Index(props) {
  return <CoursePage {...props} />;
}

export const getServerSideProps: GetServerSideProps = async ({
  params,
  req,
  res,
  locale,
  query,
}) => {
  await initalizeMiddlewares(req, res, "");
  const { kz_user_token } = req.cookies;
  const { isMobile } = getSelectorsByUserAgent(req.headers["user-agent"]);
  const lang = "tr";
  const page = Number((query.page as string) || "1");
  const perPage = 16;
  const localeHeader = convertLangToXLocale(lang as string);

  if (!query.courseSlug) {
    return {
      notFound: true,
    };
  }

  const course = await getSingleCachedCourse(query.courseSlug as string, lang);
  if (!course) {
    return {
      notFound: true,
    };
  }

  const courses = await getCachedCourses(lang);

  course.subjects = course.subjects.filter(
    (subject) => subject.has_question_seo,
  );

  saveContentLangToCookie(lang, { res });
  const headerItems = await getCachedHeaderItems(lang, "student");
  const headerBanner = await getCachedHeaderBanner(lang);

  let questions = {
    results: [],
    total: 0,
  };
  try {
    questions = await (
      req as IKunduzRequest
    ).elasticClient.getLastQuestionsByCoursePage(
      localeHeader,
      course.slug,
      page,
      perPage,
    );
  } catch (error) {
    return {
      notFound: true,
    };
  }

  if (query.page && questions?.results?.length == 0) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      course,
      courses,
      questions: questions.results,
      total: questions.total,
      page,
      perPage,
      isAuth: !!kz_user_token,
      isMobile,
      lang,
      headerItems,
      headerBanner,
      ...(await serverSideTranslations(lang, [
        "questionIndexing",
        "kunduzcom_common",
      ])),
    },
  };
};
